var _g, _g2, _g3, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHearts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_5330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.89 16.6552C64.9688 15.6045 62.8418 14.9326 60.6307 14.6777C58.4196 14.4229 56.1677 14.5902 54.0036 15.1701C51.8395 15.75 49.8056 16.731 48.0181 18.0573C46.2306 19.3835 44.7246 21.0289 43.5861 22.8995L41.2229 26.7802L37.2359 24.601C33.3555 22.4801 28.7202 21.9464 24.3499 23.1174C19.9795 24.2884 16.2321 27.0682 13.932 30.8453C11.6319 34.6223 10.9675 39.0873 12.085 43.2578C13.2025 47.4283 16.0103 50.9628 19.8908 53.0838L23.8778 55.263L53.1405 71.2572L70.4856 42.7744L72.8488 38.8937C73.9883 37.0237 74.738 34.9649 75.0552 32.835C75.3724 30.7052 75.2508 28.546 74.6974 26.4808C74.1441 24.4157 73.1698 22.485 71.8301 20.7991C70.4905 19.1131 68.8119 17.7051 66.89 16.6552Z",
    fill: "#FAEEF4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_337_5330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6719 30.1627C61.4984 30.0678 61.3064 30.0071 61.1068 29.9841C60.9072 29.9611 60.7039 29.9762 60.5085 30.0286C60.3131 30.0809 60.1295 30.1695 59.9681 30.2892C59.8068 30.409 59.6708 30.5575 59.568 30.7264L59.3547 31.0767L58.9947 30.88C58.6444 30.6885 58.226 30.6403 57.8314 30.7461C57.4369 30.8518 57.0986 31.1027 56.8909 31.4437C56.6833 31.7847 56.6233 32.1878 56.7242 32.5643C56.8251 32.9408 57.0785 33.2599 57.4289 33.4514L57.7888 33.6481L60.4306 35.092L61.9965 32.5206L62.2098 32.1703C62.3127 32.0015 62.3804 31.8156 62.409 31.6233C62.4376 31.4311 62.4266 31.2361 62.3767 31.0497C62.3267 30.8633 62.2388 30.689 62.1178 30.5368C61.9969 30.3846 61.8454 30.2574 61.6719 30.1627Z",
    fill: "#F4849F",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_337_5330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2267 45.5919C21.9017 45.3987 21.5434 45.2724 21.1722 45.2202C20.8011 45.168 20.4244 45.1908 20.0637 45.2875C19.7031 45.3841 19.3654 45.5526 19.0701 45.7834C18.7748 46.0142 18.5277 46.3028 18.3427 46.6326L17.9589 47.3168L17.2844 46.9162C16.6279 46.5263 15.8499 46.4169 15.1215 46.612C14.3931 46.8072 13.774 47.291 13.4004 47.9569C13.0268 48.6228 12.9293 49.4163 13.1293 50.1629C13.3294 50.9095 13.8106 51.5479 14.4671 51.9378L15.1416 52.3385L20.0923 55.2787L22.9096 50.257L23.2934 49.5728C23.4785 49.2431 23.5977 48.8786 23.6443 48.5001C23.6908 48.1215 23.6638 47.7364 23.5647 47.3667C23.4657 46.9971 23.2965 46.65 23.067 46.3455C22.8374 46.0409 22.5519 45.7849 22.2267 45.5919Z",
    fill: "#F4849F"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_337_5330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.157 43.9082C61.9829 43.2661 60.6831 42.8555 59.3318 42.6998C57.9806 42.544 56.6044 42.6463 55.2819 43.0006C53.9594 43.355 52.7165 43.9546 51.6241 44.765C50.5318 45.5755 49.6115 46.581 48.9157 47.7242L47.4715 50.0957L45.035 48.764C42.6636 47.4678 39.831 47.1417 37.1602 47.8573C34.4894 48.573 32.1994 50.2717 30.7937 52.5799C29.3881 54.8881 28.9821 57.6167 29.665 60.1653C30.3479 62.714 32.0638 64.874 34.4352 66.1701L36.8717 67.5019L54.7545 77.2761L65.3543 59.87L66.7985 57.4984C67.4948 56.3556 67.9529 55.0975 68.1468 53.7959C68.3406 52.4943 68.2663 51.1748 67.9282 49.9128C67.59 48.6507 66.9946 47.4709 66.1759 46.4406C65.3573 45.4103 64.3314 44.5498 63.157 43.9082Z",
    fill: "#DE204E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_337_5330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7124 53.6105L49.6571 63.554L45.0136 61.0159",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_337_5330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9612 11.5592C71.6125 11.353 71.2279 11.2184 70.8294 11.1631C70.431 11.1077 70.0265 11.1326 69.6391 11.2364C69.2517 11.3402 68.889 11.5209 68.5716 11.768C68.2543 12.0152 67.9885 12.3241 67.7895 12.677L67.3765 13.4091L66.6528 12.9816C65.9484 12.5655 65.1131 12.4495 64.3308 12.6591C63.5484 12.8687 62.8831 13.3868 62.4811 14.0994C62.0791 14.8119 61.9734 15.6606 62.1872 16.4586C62.4011 17.2567 62.9169 17.9388 63.6213 18.3549L64.3451 18.7824L69.657 21.9201L72.6885 16.5468L73.1015 15.8147C73.3006 15.4619 73.4291 15.0719 73.4796 14.6671C73.53 14.2623 73.5015 13.8505 73.3956 13.4553C73.2897 13.0601 73.1086 12.6893 72.8624 12.3639C72.6163 12.0386 72.3101 11.7651 71.9612 11.5592Z",
    fill: "#F4849F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1025 27.6922C40.849 27.443 40.548 27.2454 40.2167 27.1105C39.8854 26.9757 39.5303 26.9062 39.1717 26.9062C38.8131 26.9062 38.458 26.9757 38.1267 27.1105C37.7954 27.2454 37.4944 27.443 37.2409 27.6922L36.7148 28.2091L36.1887 27.6922C35.6766 27.1891 34.9821 26.9065 34.2579 26.9065C33.5337 26.9065 32.8392 27.1891 32.3271 27.6922C31.815 28.1953 31.5273 28.8776 31.5273 29.589C31.5273 30.3005 31.815 30.9828 32.3271 31.4858L32.8532 32.0027L36.7148 35.7963L40.5764 32.0027L41.1025 31.4858C41.3561 31.2368 41.5573 30.9411 41.6946 30.6156C41.8319 30.2902 41.9025 29.9413 41.9025 29.589C41.9025 29.2367 41.8319 28.8879 41.6946 28.5624C41.5573 28.237 41.3561 27.9413 41.1025 27.6922Z",
    fill: "#F4849F",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_5330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.4247,
    height: 71.0221,
    fill: "white",
    transform: "translate(0.941406 20.1992) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_337_5330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.7189,
    height: 6.41172,
    fill: "white",
    transform: "translate(55.7188 30.4844) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_337_5330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.4041,
    height: 12.7138,
    fill: "white",
    transform: "translate(11.1914 46.0195) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_337_5330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.4818,
    height: 43.4024,
    fill: "white",
    transform: "translate(22.8555 46.0742) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_337_5330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3765,
    height: 17.5363,
    fill: "white",
    transform: "translate(39.7852 53.3398) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_337_5330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3229,
    height: 13.5907,
    fill: "white",
    transform: "translate(60.1094 12.0312) rotate(-15)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHearts);
export default __webpack_public_path__ + "static/media/icon-hearts.018373716af0f4e20a88e4eb306ea0eb.svg";
export { ForwardRef as ReactComponent };